import template from './SubTables.html';

export default {
  name: 'subTables',
  template,
  controller() {
    const vm = this;

    /* ** public variables ** */
    vm.showData = false;
    vm.rows = [];

    vm.isObjectLike = function (value) {
      return Boolean(value) && _.isObjectLike(value) ? 'object-like' : '';
    };

    vm.toggleView = function (index) {
      vm.rows[index] = !vm.rows[index];
    };

    vm.startCase = _.startCase;
  },
  bindings: {
    data: '<'
  }
};
